module.exports = __webpack_public_path__ + "static/img/nodeJS.4bbdd3f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/article/nodeJS.jpeg
// module id = 9HlT
// module chunks = 0